import React, { useRef, useState } from 'react'
import intl from 'react-intl-universal'
import { useAppSelector, useAppDispatch } from '@/store/hooks'
import IconFont from '@/components/IconFont'
import Loading from '@/components/Loading'
import BusinessCardDrawer from '@/components/BusinessCard/BusinessCardDrawer'
import { updateRoomMembers } from '@/store/actions'
import type {businessCardDrawerRefProps} from '@/components/BusinessCard/index.d'
import type { userTypes, userInfoTypes, roomInfoTypes } from '@/store/store.d'
import { Space, Image, Dropdown, Avatar} from 'antd'
import { DownOutlined, } from '@ant-design/icons'
import styles from './index.module.scss'

// 房间成员组件
type RoomMembersPropsTypes = {
  userInfo?: userInfoTypes,
  roomId?: string,
}
const RoomMembers:React.FC<RoomMembersPropsTypes> = (props) => {
  const dispatch = useAppDispatch()
  // prefer selectors over connect
  const userInfo = useAppSelector((state: any) => state.userInfo)
  const roomId = useAppSelector((state: any) => state.roomInfo?.roomId)
  const [loading, setLoading] = useState(false)
  const [members, setMembers] = useState<userTypes[]>([])
  const businessCardDrawerRef = useRef<businessCardDrawerRefProps>(null)

  const openCard = (ctaId:number) => {
    if(userInfo?.type !== 7 && userInfo?.type !== 6){
      businessCardDrawerRef.current?.open(ctaId)
    }
  }

  // 显示下拉的时候更新在线房间用户列表
  const visibleChange = (visible: boolean) => {
    if(visible){
      setLoading(true)
      dispatch(updateRoomMembers(roomId || '', (data: userTypes[]) => {
        setLoading(false)
        setMembers(data)
      }))
    } else {
      setLoading(false)
      setMembers([])
    }
  }

  const handleMenuClick = (info: any) => {
    const key = String(info.key || '')
    if(!key) return
    const [ctaIdStr] = key.split('_')
    const ctaId = Number(ctaIdStr)
    const member = members.find(m => m.ctaId === ctaId)
    const canViewDetail = member && member.ctaId > 0 && [0, 1, 2, 3, 4].includes(member.type) && userInfo?.type && [0, 1, 2, 3, 4].includes(userInfo.type)
    if(canViewDetail){
      openCard(ctaId)
    }
  }

  const items = loading ? [
    { key: 'loading', label: <div className={styles['loading-box']}><Loading /></div>, disabled: true }
  ] : (members || []).map((user: userTypes, index:number) => {
    const canViewDetail = user.ctaId > 0 && [0, 1, 2, 3, 4].includes(user.type) && userInfo?.type && [0, 1, 2, 3, 4].includes(userInfo.type)
    return {
      key: `${user.ctaId}_${index}`,
      label: (
        <div className={styles['user-item']}>
          <Space className={styles['item__basic']}>
            <Avatar size={30} src={
              <Image preview={false} src={user?.avatar} style={{ width: '100%' }} />
            } />
            {`${user?.name}(${intl.get(`user_type.${user.type}`)})`}
          </Space>
          {
            canViewDetail &&
            <IconFont className={styles['item__icon']} type="icon-card"/>
          }
        </div>
      ),
      style: { cursor: canViewDetail ? 'pointer' : 'default' },
    }
  })

  return(
    <>
      <Dropdown
        overlayStyle={{ width: 300 }}
        onOpenChange={visibleChange}
        menu={{ items, onClick: handleMenuClick }}
      >
        <Space>
          <IconFont type="icon-user"/>
          {intl.get('header.member_list')}
          <DownOutlined />
        </Space>
      </Dropdown>
      <BusinessCardDrawer ref={businessCardDrawerRef}/>
    </>
  )
}

export default RoomMembers
